import { BaseFilter } from './base-filter.dto';
export const AddFilterDto = BaseFilter;